<template>
  <div class="indexPage">
    <div class="list">
      <div class="item" v-if="dataItem != ''">
        <div class="block_one">
          <div class="column flex-rowl">
            <p class="label">创建时间：</p>
            <p class="con">{{ dataItem.order_time }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单状态：</p>
            <p class="con">
              {{
                dataItem.service_order_status == 1
                  ? "待接单"
                  : dataItem.service_order_status == 2
                  ? "已接单"
                  : dataItem.service_order_status == 3
                  ? "取餐中"
                  : dataItem.service_order_status == 4
                  ? "送餐中"
                  : dataItem.service_order_status == 5
                  ? "待自提"
                  : dataItem.service_order_status == 6
                  ? "已送达"
                  : "已完成"
              }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单情况：</p>
            <p class="con">
              {{
                dataItem.service_order_property == 1
                  ? "服务订单进行中"
                  : dataItem.service_order_property == 2
                  ? "服务订单取消申请中"
                  : dataItem.service_order_property == 3
                  ? "服务订单已取消"
                  : "服务订单已完成"
              }}
            </p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">服务订单号：</p>
            <p class="con">{{ dataItem.service_order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单号：</p>
            <p class="con">{{ dataItem.order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐位置：</p>
            <p class="con">{{ dataItem.address_detail }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">关联取餐柜：</p>
            <p class="con">{{ dataItem.service_rating }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">用户姓名：</p>
            <p class="con">{{ dataItem.truename }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系电话：</p>
            <p class="con">{{ dataItem.customer_phone }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单内容：</p>
            <p class="con">{{ dataItem.order_content }}</p>
          </div>
        </div>

        <div class="block_three">
          <div class="column flex-rowl">
            <p class="label">取餐员：</p>
            <p class="con">{{ pickupInfo.pickup_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取餐员工号：</p>
            <p class="con">{{ pickupInfo.pickup_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ pickupInfo.pickup_staff_contact }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取餐时间：</p>
            <p class="con">{{ pickupInfo.pickup_time }}</p>
          </div>
        </div>

        <div class="block_three">
          <div class="column flex-rowl">
            <p class="label">送餐员：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐员工号：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_contact }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐时间：</p>
            <p class="con">{{ deliveryInfo.delivery_assignment_time }}</p>
          </div>
        </div>

        <div class="block_three" v-if="serinfoInfo != ''">
          <div class="column flex-rowl">
            <p class="label">分派员：</p>
            <p class="con">{{ serinfoInfo.dispatch_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">分派员工号：</p>
            <p class="con">{{ serinfoInfo.dispatch_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ serinfoInfo.dispatch_staff_contact }}</p>
          </div>
          <div class="column dispath_type flex-rowl">
            <p class="label">分派方式：</p>
            <div class="con" v-if="serinfoInfo.dispatch_result">
              <div class="block" v-if="serinfoInfo.dispatch_result == 4">
                <p>直接送达用户</p>
              </div>
              <div class="block" v-else-if="serinfoInfo.dispatch_result == 1">
                <p>已放入取餐柜</p>
                <p>{{ serinfoInfo.locker_number }}</p>
                <p>{{ serinfoInfo.locker_compartment_number }} 格（大件用）</p>
                <p>{{ serinfoInfo.locker_code }}（开柜码）</p>
              </div>
              <div class="block" v-else-if="serinfoInfo.dispatch_result == 2">
                <p>已放入取餐柜</p>
                <template v-if="serinfoInfo.locker_number">
                  <p>{{ serinfoInfo.locker_number }}</p>
                  <p>
                    {{ serinfoInfo.locker_compartment_number }} 格（小件用）
                  </p>
                  <p>{{ serinfoInfo.locker_code }}（开柜码）</p>
                </template>
              </div>
              <template
                v-if="
                  serinfoInfo.dispatch_result == 1 ||
                  serinfoInfo.dispatch_result == 2
                "
              >
                <div class="block" v-if="serinfoInfo.locker_number">
                  <div class="primary-button" @click="handleToast">
                    商品放错，重新操作
                  </div>
                  <div class="primary-button" @click="handleToast">
                    直接送达
                  </div>
                  <div class="primary-button" @click="handleToast">
                    订单取消
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="btn_group">
          <div class="btn flex-rowl">
            <div
              :class="
                !serinfoInfo.dispatch_result
                  ? 'primary-button'
                  : 'default-button'
              "
              @click="handleQuery(1)"
            >
              放入取餐柜（大件）
            </div>
          </div>
          <div class="btn flex-rowl">
            <div
              :class="
                !serinfoInfo.dispatch_result
                  ? 'primary-button'
                  : 'default-button'
              "
              @click="handleQuery(2)"
            >
              放入取餐柜（小件）
            </div>
          </div>
          <div class="btn flex-rowl">
            <div
              :class="
                !serinfoInfo.dispatch_result
                  ? 'primary-button'
                  : 'default-button'
              "
            >
              <a
                :href="'tel:' + dataItem.customer_phone"
                v-if="!serinfoInfo.dispatch_result"
                >联系用户</a
              >
              <span v-else>联系用户</span>
            </div>
          </div>
          <div class="btn flex-rowl">
            <div
              :class="
                !serinfoInfo.dispatch_result
                  ? 'primary-button'
                  : 'default-button'
              "
              @click="handleQuery(4)"
            >
              直接配送
            </div>
          </div>
        </div>
      </div>
      <van-empty
        description="该订单不存在"
        v-if="!isLoading && dataItem == ''"
      />
    </div>
  </div>
</template>
  
<script>
import {
  getOrderInfo,
  getDispatch,
  putBigCabinet,
  putSmallCabinet,
  getToken,
  getBoxState,
} from "../../api/api";
export default {
  name: "sMealIndex",
  data() {
    return {
      isRecive: true,
      type: 1,
      isLoading: true,
      userInfo: "", // 用户信息
      dataItem: "", // 订单信息
      pickupInfo: "", // 取餐信息
      deliveryInfo: "", // 送餐信息
      serinfoInfo: "", // 分配信息
      order_id: "", // 订单id
      token: "", // token

      params: {
        order_id: "",
        token: "",
        dispatch_staff_id: "",
        dispatch_result: "", // 1=放入取餐柜（大件） 2=放入取餐柜（小件） 3=联系用户 4=直接送达
      },
    };
  },
  created() {
    let { id } = this.$route.params;
    this.order_id = id;
    this.params.order_id = id;
    this.token = this.$store.state.Authorization;
    this.params.token = this.$store.state.Authorization;
    this.params.dispatch_staff_id = this.$store.state.USERINFO.accountid;
    this.userInfo = this.$store.state.USERINFO;
    this.getToken();
  },
  methods: {
    // 获取token
    getToken(isSubmit) {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);

          if (isSubmit) {
            this.getDispatch(res.data.token);
          } else {
            this.getOrderInfo(res.data.token);
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 查看取餐订单
    getOrderInfo(token) {
      let { order_id } = this;
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderInfo({ order_id, token }).then((res) => {
        if (res.error_code == 0) {
          if (
            Object.values(res.data).length != 0 &&
            Object.values(res.data.pickup).length != 0 &&
            Object.values(res.data.delivery).length != 0
          ) {
            this.dataItem = res.data;
            this.pickupInfo = res.data.pickup;
            this.deliveryInfo = res.data.delivery;
            this.serinfoInfo =
              Object.values(res.data.serinfo).length != 0
                ? res.data.serinfo
                : "";
            // if( Object.values(res.data.serinfo).length == 0) {
            //   this.getDispatch(token)
            // }
          } else {
            this.dataItem = "";
          }
          this.isLoading = false;
          toast.clear();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
          this.isLoading = false;
          toast.clear();
        }
      });
    },

    handleQuery(type) {
      let { dataItem } = this;
      if (dataItem.service_order_status == 7) return;
      if (type == 1) {
        this.params.dispatch_result = 1;
        // this.$toast("即将开放");
      } else if (type == 2) {
        this.params.dispatch_result = 2;
        // this.$toast("即将开放");
      } else if (type == 3) {
        this.params.dispatch_result = 3;
      } else if (type == 4) {
        this.params.dispatch_result = 4;
      }
      this.getToken(true);
    },

    getDispatch(token) {
      let { params } = this;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
      });
      params.token = token;
      getDispatch(params).then((res) => {
        if (res.error_code == 0) {
          toast.clear();
          this.$toast.success(res.message);
          if (params.dispatch_result == 1) {
            this.putBigCabinet(token);
          } else if (params.dispatch_result == 2) {
            this.putSmallCabinet(token);
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 放入大柜
    putBigCabinet(token) {
      let { order_id } = this;
      putBigCabinet({ token, order_id }).then((res) => {
        if (res.error_code != 0) {
          this.$toast.error(res.message || "服务器异常，请稍后");
        } else {
          setTimeout(() => {
            this.getOrderInfo(token);
          }, 1500);
        }
        // this.getBoxState(token);
      });
    },
    // 放入小柜
    putSmallCabinet(token) {
      let { order_id } = this;
      putSmallCabinet({ token, order_id }).then((res) => {
        if (res.error_code != 0) {
          this.$toast.error(res.message || "服务器异常，请稍后");
        } else {
          setTimeout(() => {
            this.getOrderInfo(token);
          }, 1500);
        }
        // this.getBoxState(token);
      });
    },

    // 查询开箱结果
    getBoxState(token) {
      let { order_id } = this;
      const toast = this.$toast.loading({
        message: "开箱中，请稍后...",
        forbidClick: true,
      });
      getBoxState({ token, order_id, opType: 6 }).then((res) => {
        if (res.error_code == 0) {
          setTimeout(() => {
            toast.clear();
            this.$toast.success(res.message);
            this.getOrderInfo(token);
          }, 10000);
        } else {
          this.$toast.error(res.message || "服务器异常，请稍后");
        }
      });
    },

    handleToast() {
      this.$toast("即将开放");
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  padding-top: 40px;
  padding-bottom: 200px;
  .list {
    .item {
      width: 660px;
      min-height: 700px;
      background: #ffffff;
      border: 6px solid #e6e6e6;
      border-radius: 40px;
      margin: 0 auto 30px;
      padding: 52px 44px 0;
      box-sizing: border-box;
      font-size: 28px;
      color: #040000;
      .block_one {
        font-size: 22px;
        margin-bottom: 65px;
        .column {
          .label {
            width: 140px;
          }
        }
      }
      .block_two {
        margin-bottom: 99px;
      }
      .block_three {
        margin-bottom: 85px;
      }
      .column {
        align-items: flex-start;
        &:nth-child(2n) {
          margin: 26px 0;
        }
        .label {
          white-space: nowrap;
          width: 190px;
          flex-shrink: 0;
        }
        .con {
          word-wrap: break-word;
          flex-shrink: 0;
          width: 380px;
        }
      }
      .btn {
        margin-bottom: 30px;
        .primary-button {
          width: 360px;
        }
        .default-button {
          width: 360px;
        }
        a {
          display: block;
          height: 100%;
          width: 360px;
          color: #fff;
        }
      }
      .dispath_type {
        align-items: flex-start;
        p {
          &:nth-child(2n) {
            margin: 18px 0;
          }
        }
        .primary-button {
          height: 60px;
          line-height: 60px;
          margin-bottom: 25px;
          width: 280px;
          box-sizing: border-box;
          font-size: 16px;
          &:first-child {
            margin-top: 40px;
          }
        }
      }
    }
  }
}
</style>